<div id="basic" class="flex">
  <div name="right-banner" class="hidden md:block flex justify-center md:w-1/2 px-20">
    <div class="mb-8 flex flex-col justify-center">
      <div class="pt-12 pb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty?.thumb}}>
      </div>
      <div class="flex justify-between items-end">
        <div>
          <p><span class="text-lg font-bold">${{displayedRentRateOrRange}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty?.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty?.baths}}</span> ba | <span
              class="font-bold">{{modelProperty?.sqft}}</span> sqft</p>
        </div>
      </div>
      <div class="pb-4">
        <div>{{modelProperty?.title}}</div>
      </div>
      <div>
        <div *ngIf="splashHTML != null" class="bg-white h-32" [innerHTML]="splashHTML"></div>
      </div>
    </div>
  </div>
  <div name="main" class="p-8 flex flex-col sm:w-auto md:w-1/2  bg-white">
    <div class="flex flex-col sm:w-auto md:hidden">
      <div class="mb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty?.thumb}}>
      </div>
      <div class="flex justify-between items-end ">
        <div>
          <p><span class="text-lg font-bold">${{displayedRentRateOrRange}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty?.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty?.baths}}</span> ba | <span
              class="font-bold">{{modelProperty?.sqft}}</span> sqft</p>
        </div>
      </div>
      <div>
        <div>{{modelProperty?.title}}</div>
      </div>
    </div>
    <div class="md:px-16">
      <div>
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Rental Application</h2>
        </div>
        <div class="flex box-border-active pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-9">
            <h2 class="text-lg font-bold my-6">Contact Information</h2>
            <p *ngIf="AddAdditionalApplicantKey == null">Please complete each field below.</p>
            <p *ngIf="AddAdditionalApplicantKey != null && AddAdditionalApplicantName == null">Please complete each
              field below for the additional applicant.</p>
            <p *ngIf="AddAdditionalApplicantKey != null && AddAdditionalApplicantName != null">Please complete each
              field below for {{AddAdditionalApplicantName}}.</p>
            <div *ngIf="errorMessage!=null" class="alert alert-danger">
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isLoading" class="spinner">
        <mat-spinner></mat-spinner>
        Loading Data....
      </div>
      <form *ngIf="!isLoading" id="basic-info" #basicForm="ngForm" class="flex flex-col pt-8">
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>First Name</mat-label>
            <input matInput name="FirstName" id="FirstName" required [(ngModel)]="model.FirstName" #FirstName="ngModel">
            <mat-error>Please enter a name</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Middle Name</mat-label>
            <input matInput name="MiddleName" id="MiddleName" [(ngModel)]="model.MiddleName" #MiddleName="ngModel">
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Last Name</mat-label>
            <input matInput name="LastName" id="LastName" required [(ngModel)]="model.LastName" #LastName="ngModel">
            <mat-error>Please enter a name</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Email Address</mat-label>
            <input matInput name="Email" id="Email" required readonly email [(ngModel)]="model.Email" #Email="ngModel">
            <mat-error>Please enter a valid email address</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Home Phone</mat-label>
            <mat-input-tel name="HomePhone" id="HomePhone" required [(ngModel)]="homePhoneNumber" #HomePhone="ngModel">
            </mat-input-tel>
            <mat-error>Please enter a valid phone number</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Cell Phone</mat-label>
            <mat-input-tel name="CellPhone" id="CellPhone" required [(ngModel)]="cellPhoneNumber" #CellPhone="ngModel">
            </mat-input-tel>
            <mat-error>Please enter a valid phone number</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Move-In Date</mat-label>
            <input matInput [matDatepicker]="desiredMoveInDate" name="DesiredMoveInDate" id="desiredMoveInDate"
              [(ngModel)]="model.DesiredMoveInDate" [matDatepickerFilter]=dateFilter
              (dateChange)="onMoveInDateChange($event)" #DesiredMoveInDate="ngModel" [disabled]="!model.IsPrimary"
              [matTooltip]="!model.IsPrimary ? 'selected by primary applicant' : null">
            <mat-datepicker-toggle matSuffix [for]="desiredMoveInDate"></mat-datepicker-toggle>
            <mat-datepicker #desiredMoveInDate></mat-datepicker>
            <mat-error>Please fill out this field MM/DD/YYYY</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="fill" class="w-full my-2">
            <mat-label>Available Lease Terms</mat-label>
            <mat-select [(ngModel)]="model.LeaseTerm" name="LeaseTerm" required (selectionChange)="updateRentalRate()"
              [disabled]="!model.IsPrimary" [matTooltip]="!model.IsPrimary ? 'selected by primary applicant' : null">
              <mat-option *ngFor="let leaseTerm of leaseTermOptions" [value]="leaseTerm.value">
                {{leaseTerm.label}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="hidden sm:flex sm:justify-end">
          <button mat-button color="accent" class="" (click)="pricingCalendarClick()"
            [disabled]="!model.IsPrimary">Pricing Calendar</button>
        </div>
        <div class="grid grid-cols-1 grid-rows-2 gap-4 p-1 md:grid-cols-2 md:grid-rows-none md:gap-12 md:p-4">
          <div class="my-4 text-center flex flex-col bg-beige-tricon p-4 border-solid border-vivid-blue border-2">
            <div class="dashboard-card">
              <div *ngIf="!model.DesiredMoveInDate || !model.LeaseTerm" class="card-content">
                <h2 class="text-lg pb-4">CURRENT SELECTION</h2>
                <p class="text-2xl font-bold my-2">N/A</p>
                <p class="mt-8 italic">Please select a move-in date above</p>
              </div>
              <div *ngIf="model.DesiredMoveInDate && model.LeaseTerm" class="card-content">
                <h2 class="text-lg pb-4">CURRENT SELECTION</h2>
                <p class="text-2xl font-bold my-2">{{displayedRentRate | currency : 'USD' : 'symbol' :
                  '1.0-0' }}/month</p>
                <p class="my-2">{{model.LeaseTerm}} months</p>
                <p class="my-2">Move-In Date: {{model.DesiredMoveInDate | date:'shortDate'}}</p>
              </div>
            </div>
          </div>
          <div class="my-4 text-center flex flex-col bg-beige-tricon p-4 border-solid border-vivid-blue border-2">
            <div class="dashboard-card">
              <div class="card-content">
                <h2 class="text-lg pb-4">BEST VALUE!</h2>
                <p class="text-2xl font-bold my-2">{{rentalRates.BestLeaseTermRent | currency : 'USD' : 'symbol' :
                  '1.0-0' }}/month</p>
                <p class="my-2">{{rentalRates.BestLeaseTerm}} months</p>
                <p class="my-2">Move-In Date: {{rentalRates.BestLeaseTermDate | date:'shortDate'}}</p>
                <p class="mt-4 flex justify-center">
                  <button mat-flat-button color="primary" class="px-4 w-3/4" (click)="selectBestTerm()"
                    [disabled]="!model.IsPrimary">SELECT</button>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Did you work with an external agent?</mat-label>
            <mat-select name="HasExternalAgent" id="HasExternalAgent" required [(ngModel)]="model.HasExternalAgent"
              #HasExternalAgent="ngModel">
              <mat-option *ngFor="let hasExternalAgentOption of hasExternalAgentOptions"
                [value]="hasExternalAgentOption.value">
                {{hasExternalAgentOption.label}}
              </mat-option>
            </mat-select>
            <mat-error>Please fill out this field</mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="model.HasExternalAgent">
          <mat-form-field class="w-full my-2">
            <mat-label>External Agent Name</mat-label>
            <input matInput name="ExternalAgentName" id="ExternalAgentName" required
              [(ngModel)]="model.ExternalAgentName" #ExternalAgentName="ngModel">
            <mat-error>Please fill out this field</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Referred By One of Our Residents</mat-label>
            <mat-select name="hasReferrals" id="hasReferrals" required [(ngModel)]="model.hasReferrals"
              #hasReferrals="ngModel">
              <mat-option *ngFor="let hasReferralOption of hasReferralOptions" [value]="hasReferralOption.value">
                {{hasReferralOption.label}}
              </mat-option>
            </mat-select>
            <mat-error>Please fill out this field</mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="model.hasReferrals">
          <mat-form-field class="w-full my-2">
            <mat-label>Full Name</mat-label>
            <input matInput name="ReferralName" id="ReferralName" required [(ngModel)]="model.ReferralName"
              #ExternalAgentName="ngModel" #ReferralName="ngModel">
            <mat-error>Please fill out this field</mat-error>
          </mat-form-field>
        </div>
        <re-captcha size="invisible" #invisible></re-captcha>
        <div class="text-right">
          <button mat-flat-button color="primary" (click)="onSubmit()" class="h-10 px-6 my-2"
            [disabled]="!basicForm.form.valid || disableSubmitBtn">CONTINUE</button>
        </div>
      </form>
    </div>
  </div>
</div>
